// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Tags/Content/mutation-delete-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_TaskInsertNew_Tags_Content($id: uuid!) {
  delete_tasks_tags_by_pk(id: $id) {
    id
  }
}

`